module.exports = __webpack_public_path__ + "img/pyramid_green.b7dc460e.png";